import { postData } from "../common/Apicall";

export const getAllEnquiryApi = (enquiryFrom) => {
    return postData("/api/v1/enquiry/getInquiries", { enquiryFrom });
};

export const getAllSellerEnquiryApi = (enquiryTo) => {
    return postData("/api/v1/enquiry/getSellerInquiries", { enquiryTo });
};

export const createInquiryApi = (
    productID,
    enquiryFrom,
    enquiryTo,
    content,
    quantity,
    email,
    contactNumber
  ) => {
    return postData("/api/v1/enquiry/createInquiry", {
      productID,
      enquiryFrom,
      enquiryTo,
      content,
      quantity,
      email,
      contactNumber,
    });
  };